import React, { useEffect, useState } from "react";
import { MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  Activity,
  FeedbackD,
} from "src/modules/fithub-shared/notifications/index.types";

const ActivityItem: React.FC<{
  activity: Activity;
  selected: boolean;
  select: (id: string) => void;
}> = ({ activity, selected, select }) => {
  const nav = useNavigate();

  const [data, setData] = useState<{
    fun: (() => void) | null;
    message: string;
  }>({ fun: null, message: "" });

  useEffect(() => {
    Action();
  }, []);

  function Action() {
    const { plan, exercise, feedback } = (activity as Activity<FeedbackD>).data;

    switch (activity.type) {
      default:
        break;
      case "FEEDBACK":
        setData({
          fun: () => nav(`/student/progression?plan=${plan}&exc=${exercise}`),
          message: feedback,
        });
        break;
    }
  }

  function DismissNotf() {
    select(activity.id);
  }

  function cta() {
    return data.fun ? data.fun() : console.log("no action");
  }

  return (
    <div className="flex w-full flex-col rounded-sm p-2.5">
      {/* Clickable Item */}
      <button
        onClick={cta}
        className="flex w-full cursor-pointer items-center justify-between text-left active:opacity-50"
      >
        <div className="flex flex-1 flex-col">
          <h4 className="text-xs font-semibold text-zinc-900 dark:text-zinc-100">
            {activity.title}
          </h4>
          <h5 className="text-sm text-zinc-700 dark:text-zinc-300">
            {data.message}
          </h5>
        </div>
        <span className="flex w-[95px] flex-shrink-0 items-center justify-between rounded-full bg-zinc-100 bg-blend-darken dark:bg-zinc-800">
          <h6 className="pl-1.25 text-xs font-semibold uppercase text-zinc-700 dark:text-zinc-200">
            Progressão
          </h6>
          <MdChevronRight className="text-zinc-500 dark:text-zinc-300" />
        </span>
      </button>
      {/* Remove Button */}
      <button
        onClick={DismissNotf}
        className={`mt-2 self-start text-xs underline transition-colors duration-100 ${
          selected
            ? "font-bold text-red-500"
            : "text-zinc-400 hover:text-red-500"
        }`}
      >
        Arquivar
      </button>
    </div>
  );
};

export default ActivityItem;
